import { ZodIssue } from 'zod';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

export const ErrorMessageZodSchema = ({ fields }: { fields: ZodIssue[] }) => {
  return (
    <>
      <Font variant={'body2'}>
        <Text tId={'ERROR_MESSAGE_ZOD_SCHEMA'} />
      </Font>
      <ul style={{ paddingInlineStart: 16 }}>
        {fields.map((field) => (
          <li key={field.message} style={{ marginBottom: 8 }}>
            <Font variant={'body2'}>
              <strong>{field.path}</strong>
              {': '}
              {field.message}
            </Font>
          </li>
        ))}
      </ul>
    </>
  );
};
